/**
 * Couleur + transparence, valable pour N'IMPORTE QUEL format de couleur.
 *
 * Coller deux chiffres hexadécimaux derrière une couleur (`${couleur}33`) n'est valide que si la
 * couleur est un `#rrggbb` : avec `var(--x)`, `rgb(…)` ou un nom, la déclaration entière est
 * ignorée par le navigateur (fond absent, bordure absente, texte blanc sur blanc). Ici :
 *   - `#rgb` / `#rrggbb` → on garde l'écriture hexadécimale (compatible partout, y compris
 *     html2canvas/PDF), aucun changement visuel ;
 *   - tout le reste     → `color-mix(in srgb, <couleur> P%, transparent)`.
 * @param {string} couleur
 * @param {string} octetHex deux chiffres hexadécimaux, ex. '33' (≈ 20 %)
 */
export function alpha(couleur, octetHex) {
  const c = String(couleur ?? '').trim();
  if (!c) return 'transparent';
  const hex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(c);
  if (hex) {
    const plein = hex[1].length === 3 ? hex[1].split('').map((x) => x + x).join('') : hex[1];
    return `#${plein}${octetHex}`;
  }
  const pct = Math.round((parseInt(octetHex, 16) / 255) * 100);
  return `color-mix(in srgb, ${c} ${pct}%, transparent)`;
}
